// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__WNFJ5"};